// Admin/Employee surface switcher. Only renders when caller is an admin.
// Admin status comes from the shared cached store so this can never disagree
// with useAdminGuard, and never blanks out on a transient query failure.
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useAdminOrgs } from '@/lib/admin/adminStatus';
import { cn } from '@/lib/utils';

export function RoleSwitcher({ current }: { current: 'admin' | 'employee' }) {
  const { user } = useAuth();
  const { status } = useAdminOrgs(user?.id ?? null);

  if (status !== 'ready') return null;


  return (
    <div className="px-3 pt-3">
      <div className="flex items-center gap-1 p-1 rounded-md bg-muted/60 border border-border">
        <NavLink
          to="/app/employee"
          className={cn(
            'flex-1 text-center text-xs py-1.5 rounded transition-colors',
            current === 'employee'
              ? 'bg-background text-foreground shadow-sm font-medium'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          Employee
        </NavLink>
        <NavLink
          to="/app/admin"
          className={cn(
            'flex-1 text-center text-xs py-1.5 rounded transition-colors',
            current === 'admin'
              ? 'bg-background text-foreground shadow-sm font-medium'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          Admin
        </NavLink>
      </div>
    </div>
  );
}
